// 当前时间距离 传入时间的 小时数
export default function getHoursDiffFromNow(time: Date) {
  
    const now: Date = new Date();
    const inputTime: Date = new Date(time);
    
    const diffMs = (+inputTime) - (+now); // 毫秒差
    const diffHours = Math.ceil(diffMs / (1000 * 60 * 60)); // 转换成小时并向上取整
    
    return diffHours;
  }